import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const Refuge: Portfolio = {
    path: "refuge", name: "Refuge", pageStyle: PageStyle.Tan, pieces: [
        {image: "refuge-01.jpg", thumbAlt: "Refuge", title: "Bedlam Stacks", size: "30 \u00d7 22", pixelWidth: 481, pixelHeight: 360},
        {image: "refuge-02.jpg", thumbAlt: "Refuge", title: "Congregations", size: "30 \u00d7 22", pixelWidth: 480, pixelHeight: 360},
        {image: "refuge-03.jpg", thumbAlt: "Refuge", title: "Dream Room", size: "30 \u00d7 22", pixelWidth: 476, pixelHeight: 360},
        {image: "refuge-04.jpg", thumbAlt: "Refuge", title: "Enso Temple", size: "22 \u00d7 30", pixelWidth: 270, pixelHeight: 360},
        {image: "refuge-05.jpg", thumbAlt: "Refuge", title: "Enso Village", size: "30 \u00d7 22", pixelWidth: 490, pixelHeight: 360},
        {image: "refuge-06.jpg", thumbAlt: "Refuge", title: "Old Town", size: "10 \u00d7 12", pixelWidth: 266, pixelHeight: 360},
        {image: "refuge-07.jpg", thumbAlt: "Refuge", title: "Temple", size: "22 \u00d7 30", pixelWidth: 292, pixelHeight: 360},
        {image: "refuge-08.jpg", thumbAlt: "Refuge", title: "The Way", size: "14 \u00d7 16", pixelWidth: 317, pixelHeight: 360},
        {image: "refuge-09.jpg", thumbAlt: "Refuge", title: "Totem", size: "22 \u00d7 30", pixelWidth: 268, pixelHeight: 360}
    ],
    statement: {
        leftColumn: [
            "In the wake of three challenging years, images of \"structures\" come to mind to symbolize refuge, " +
            "isolation, connection and community. This body of work means to evoke stability and a sense of " +
            "lightness and hope. The elements are playful and irreverent, falling over and into each other. The " +
            "colors extend the thoughts of future brightness.",
            "A few symbolize isolation and the the past, the profound loneliness of some during the pandemic."
        ],
        rightColumn: [
            "The main message is \"village,\" and how important that concept has been, whether it be physical or " +
            "conceptual presence. The inspiration is the multitude of kindnesses and the immense mutual care for " +
            "each other. People speak of \"silver linings\" and there were many.",
            "The collage elements are repurposed prints…the elements carry the past. The resolution acknowledges " +
            "the present."
        ]
    }
};

export default Refuge;